module.exports = __webpack_public_path__ + "static/media/location.ec4c1500.svg";